import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'formatChatMessage'
})
export class FormatChatMessagePipe implements PipeTransform {
  
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text) return '';
    
    let formatted = text;
    
    // Convert numbered lists (1. 2. 3. etc.)
    formatted = formatted.replace(/(\d+)\.\s\*\*(.*?)\*\*:/g, '<div class="chat-list-item"><strong class="chat-number">$1.</strong> <strong>$2</strong></div>');
    formatted = formatted.replace(/(\d+)\.\s\*\*(.*?)\*\*/g, '<div class="chat-list-item"><strong class="chat-number">$1.</strong> <strong>$2</strong></div>');
    formatted = formatted.replace(/(\d+)\.\s(.*?):/g, '<div class="chat-list-item"><strong class="chat-number">$1.</strong> $2</div>');
    
    // Convert bullet points
    formatted = formatted.replace(/[-•]\s/g, '<div class="chat-bullet-item">• ');
    
    // Convert bold text **text**
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    
    // Convert italic text *text*
    formatted = formatted.replace(/\*(.*?)\*/g, '<em>$1</em>');
    
    // Convert line breaks
    formatted = formatted.replace(/\n/g, '<br>');
    
    // Add closing divs for list items
    formatted = formatted.replace(/<div class="chat-list-item">(.*?)<br>/g, '<div class="chat-list-item">$1</div>');
    formatted = formatted.replace(/<div class="chat-bullet-item">(.*?)<br>/g, '<div class="chat-bullet-item">$1</div>');
    
    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }
}
